import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            Shop by Category
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-lg mx-auto">
            Browse our complete collection of products across all categories on Kaspreadsheet.
            Click any category to start shopping.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center bg-white rounded-lg border border-background-200/70 hover:border-primary-300 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="w-full aspect-square overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} - Shop on Kaspreadsheet`}
                  title={`${cat.name} - GTBuy Spreadsheet Shopping Category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col items-center gap-1 py-4 px-3 w-full">
                <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors text-center leading-tight whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-[10px] md:text-xs text-foreground-400 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                  Shop Now &rarr;
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}